'use client';

import CheckoutFlow, { CheckoutFlowProps } from './checkout-flow';

/**
 * CheckoutModal - Wrapper component for rendering CheckoutFlow in modal context
 *
 * This component is used by the ModalProvider when MODAL_TYPES.CHECKOUT is shown.
 * It passes through all props to CheckoutFlow and handles any modal-specific concerns.
 */
export default function CheckoutModal(props: CheckoutFlowProps) {
  return (
    <div className="checkout-modal-content">
      <CheckoutFlow {...props} />
    </div>
  );
}
